import React, { ReactElement } from "react";

import TabsNav from "./TabsNav";
import { TabPane, TabsWrapper, TabsPaneWrapper } from "./styled";
import { TabsProps } from "./types";

const Tabs = ({ tabs }: TabsProps): ReactElement => {
  const selectedTab = tabs.find(tab => tab.isSelected);
  const selectedTabPane =
    selectedTab && selectedTab.content ? (
      <TabsPaneWrapper>
        <TabPane>{selectedTab.content}</TabPane>
      </TabsPaneWrapper>
    ) : null;

  return (
    <TabsWrapper>
      <TabsNav tabs={tabs} />
      {selectedTabPane}
    </TabsWrapper>
  );
};

export default Tabs;
